import React, { useMemo } from 'react';

import ArticleList, { type ArticleListItem } from '../components/ArticleList';
import { useNews } from '../hooks/useNews';
import { strings } from '../strings';
import { usePageMeta } from '../utils/pageMeta';

const NewsScreen = () => {
  const { news, isLoading, error } = useNews();
  usePageMeta(strings.pageMeta.news);

  // `fetchNews` already merged every website into one list sorted newest
  // first; each row keeps its website as the caption and shows the article's
  // Jalali publication time and short description.
  const items = useMemo<ArticleListItem[]>(
    () =>
      news.map(article => ({
        key: `${article.source.title}-${article.title}-${article.link}`,
        title: article.title,
        caption: article.source.title,
        time: article.jalaliTime,
        description: article.desc,
        url: article.link,
      })),
    [news],
  );

  return (
    <ArticleList
      title={strings.newsLabel}
      items={items}
      isLoading={isLoading}
      error={error}
    />
  );
};

export default NewsScreen;
